import React, { createContext, useContext, useState, useCallback } from 'react';
import { Snackbar, Alert } from '@mui/material';

type ToastFn = (message: string, severity?: 'success' | 'info' | 'error' | 'warning') => void;

const ToastContext = createContext<ToastFn>(() => {});

/** App-wide toast (matches the prototype's BQ.toast). */
export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState<{ open: boolean; message: string; severity: 'success' | 'info' | 'error' | 'warning' }>({
    open: false, message: '', severity: 'success',
  });

  const toast = useCallback<ToastFn>((message, severity = 'success') => {
    setState({ open: true, message, severity });
  }, []);

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <Snackbar
        open={state.open}
        autoHideDuration={2400}
        onClose={() => setState((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity={state.severity} variant="filled" sx={{ borderRadius: '10px' }} onClose={() => setState((s) => ({ ...s, open: false }))}>
          {state.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};

export const useToast = (): ToastFn => useContext(ToastContext);
